import {Inject, Injectable} from '@angular/core';
import {Store} from "@ngrx/store";
import {locationsFeature, LocationsState} from "../../state/locations/locations.state";
import {LocationActions, LocationsAPiActions, LocationsChannelActions} from "../../state/locations/locations.actions";
import {LocationHolderType} from "../../../types/locationHolder.type";
import {Observable} from "rxjs";
import {LocationModel} from "../../../models/location.model";

@Injectable()
export class LocationsFacadeService {

  constructor(@Inject(Store) private store: Store<LocationsState>) {
  }

  subscribeToChannels(ids?: string[]) {
    this.store.dispatch(LocationsChannelActions.subscribe());
  }

  unsubscribeFromChannels(ids?: string[]) {
    this.store.dispatch(LocationsChannelActions.unsubscribe());
  }

  removeLocationsByIds(ids: string[]) {
    this.store.dispatch(LocationActions.removeLocations({ids: ids}));
  }

  removeAllLocations() {
    this.store.dispatch(LocationActions.removeAll());
  }

  selectLocation(id: string) {
    return this.store.select(locationsFeature.selectLocation(id));
  }

  getLocation(holderId: string, holder: LocationHolderType): void {
    this.store.dispatch(LocationsAPiActions.getLocation({holderId: holderId, holder: holder}));
  }

  selectLocations() {
    return this.store.select(locationsFeature.selectAll);
  }

  setLocations(locations: LocationModel[]) {
    this.store.dispatch(LocationActions.setLocations({locations: locations}));
  }

  getLocations(payload: { holderId: string, holder: LocationHolderType }[]) {
    if (!payload.length) {
      return;
    }
    this.store.dispatch(LocationsAPiActions.getLocations({payload: payload}));
  }

}
